import {defineStore} from 'pinia'
import reportController from "@/controller/reportController";

export const useReportStore = defineStore('report', {
    state: () => {
        return {}
    },
    getters: {},
    actions: {
        columns(params) {
            return reportController.columns(params)
        },
        scriptList() {
            return reportController.scriptList();
        },
        preview(reportId,elementId,params) {
            return reportController.preview(reportId,elementId,params);
        },

    },
})